export default theme => ({
  root: {
    flexGrow: 1,
    flexBasis: '14.28571428571%',
    maxWidth: '14.28571428571%',
    height: 75,
    // position: 'relative',
    // width: 150,
    marginBottom: 20
  },

  logo: {
    // filter: 'grayscale(100%)',
    // width: '100%',
    width: 160,

    // '&:hover': {
    //   filter: 'grayscale(0%)'
    // }
  }
});